module.exports = __webpack_public_path__ + "static/media/NavContactIcon.6aee5ad9.svg";